"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoolDepartureTimeDetails = getPoolDepartureTimeDetails;
const constants_1 = require("@daytrip/constants");
const date_utils_1 = require("./date-utils");
/**
 * WARNING: The first argument (`poolOffer`) isn't typed because we need to re-use the model definition from inside `api/` but we don't have the monorepo setup to do it.
 * @param poolOffer should be of type Pick<PoolOffer, "departureTimeEarliest" | "departureTimeLatest" | "originTimezone">
 * @param meetingPosition
 * @returns
 */
function getPoolDepartureTimeDetails(poolOffer, meetingPosition) {
    // Minutes might be defined as 0 so we need to check for property existence
    const minutesFromDepartureAtEarliestTimeIsDefined = typeof meetingPosition?.minutesFromDepartureAtEarliest === "number";
    const minutesFromDepartureAtLatestTimeIsDefined = typeof meetingPosition?.minutesFromDepartureAtLatest === "number";
    const minutesFromDepartureAtEarliestInMs = minutesFromDepartureAtEarliestTimeIsDefined
        ? meetingPosition.minutesFromDepartureAtEarliest * constants_1.MINUTE_IN_MILLISECONDS
        : 0;
    const minutesFromDepartureAtLatestInMs = minutesFromDepartureAtLatestTimeIsDefined
        ? meetingPosition.minutesFromDepartureAtLatest * constants_1.MINUTE_IN_MILLISECONDS
        : 0;
    const departureTimeAtEarliestInMs = poolOffer.departureTimeEarliest * constants_1.SECOND_IN_MILLISECONDS + minutesFromDepartureAtEarliestInMs;
    const departureTimeAtLatestInMs = minutesFromDepartureAtLatestTimeIsDefined
        ? poolOffer.departureTimeEarliest * constants_1.SECOND_IN_MILLISECONDS + minutesFromDepartureAtLatestInMs
        : poolOffer.departureTimeLatest * constants_1.SECOND_IN_MILLISECONDS;
    const formattedDepartureTimeRange = (0, date_utils_1.formatHourTimespan)(departureTimeAtEarliestInMs, departureTimeAtLatestInMs, poolOffer.originTimezone);
    const departureHasTimeRange = formattedDepartureTimeRange.includes("-");
    const formattedDepartureTimeText = `${departureHasTimeRange ? "between" : "at"} ${formattedDepartureTimeRange.replace("-", "and")}`;
    const formattedDepartureTimeEarliest = formattedDepartureTimeRange.split(" -")[0];
    return {
        departureTimeAtEarliestInMs,
        departureTimeAtLatestInMs,
        formattedDepartureTimeRange,
        formattedDepartureTimeEarliest,
        formattedDepartureTimeText,
        departureHasTimeRange,
    };
}
//# sourceMappingURL=getPoolDepartureTimeDetails.js.map